// notifications/reducer.ts
import { Action } from 'redux';
import { SET_NOTIFICATION_RESPONSE, SET_ALL_NOTIFICATION_RESPONSES, REMOVE_NOTIFICATION_ITEM } from './actions';
import { NotificationType } from '../types';

export type NotificationsState = Record<NotificationType, any>;

interface NotificationsAction extends Action {
  payload: any;
}

const initialState: NotificationsState = {
  INTERRUPTION: {},
  LEAD_NEW: {},
  LEAD_STALE: {},
  POLICY: {},
  COMMERCIAL_STATE: {},
  BROWSER_WARNING: {},
};

export const notificationsReducer = (state = initialState, action = {} as NotificationsAction): NotificationsState => {
  switch (action.type) {
    case SET_NOTIFICATION_RESPONSE:
      return {
        ...state,
        [action.payload.type]: action.payload.response,
      };
    case SET_ALL_NOTIFICATION_RESPONSES:
      return {
        ...state,
        ...action.payload,
      };
    case REMOVE_NOTIFICATION_ITEM: {
      const newState = { ...state };
      newState[action.payload.type as NotificationType] = {};
      return newState;
    }
    default:
      return state;
  }
};
